import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY } from '@/modules/user/queries/useEmployeeViewData.query';

import { EMPLOYEE_PERSONAL_INFO_QUERY_KEY } from './useEmployeePersonalInfo.query';

const useConfirmAddressQuery = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (addressId: number) => api.post(API_URL.ADDRESSES_CONFIRM_BY_ADDRESS_ID(addressId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [EMPLOYEE_PERSONAL_INFO_QUERY_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  const confirmAddress = useCallback(
    async (addressId: number) => {
      await mutation.mutateAsync(addressId);
    },
    [mutation]
  );

  return { confirmAddress, isLoading: mutation.isLoading };
};

export default useConfirmAddressQuery;
